import useIsTreeHierarchyEnabled from './useIsTreeHierarchyEnabled';

const useExtraPayload = Context => {
  const isTreeHierarchyEnabled = useIsTreeHierarchyEnabled(Context);

  return {
    ...(isTreeHierarchyEnabled && { version: 'v3' })
  };
};

export default useExtraPayload;
